export default "__VITE_ASSET__58375ebb__"